<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="fb_date"
          :label="customLabel.fb_date || '申请日期'"
          v-model="form.main.fb_date"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="fb_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_type || "预算类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.fb_type"
              placeholder="请选择"
            >
              <option>个人</option>
              <option>部门</option>
              <option>公司</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell"
          slot="fb_emname"
          v-if="form.main.fb_type == '部门'"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_emname || "申请人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fb_emname }}
          </div>
        </div>
        <employee-field
          v-else
          slot="fb_emname"
          :label="customLabel.fb_emname || '申请人'"
          v-model="form.main.fb_emname"
          @select="onSelectPleaseman($event, form.main)"
        />
        <div
          class="weui-cell"
          slot="fb_dpname"
          v-if="form.main.fb_type == '个人'"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_dpname || "申请部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              disabled
              v-model="form.main.fb_dpname"
              placeholder="选择申请人后自动填写"
            />
          </div>
        </div>
        <department-field
          v-else
          slot="fb_dpname"
          v-model="form.main.fb_dpname"
          @select="onSelectDepartment"
        />
        <div
          class="weui-cell weui-cell_access"
          slot="fb_year"
          @click="selectYear"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">年份</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fb_year }}
          </div>
          <div class="weui-cell__ft"></div>
        </div>

        <div class="weui-cell" slot="fb_total">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_total || "本年预算总额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ numberFormat(form.main.fb_total, "#,##0.00") }}
          </div>
        </div>
        <div class="weui-cell" slot="fb_pretotal">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_pretotal || "上年预算总额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ numberFormat(form.main.fb_pretotal, "#,##0.00") }}
          </div>
        </div>
        <div class="weui-cell" slot="fb_growthrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fb_growthrate || "实际增长率%"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fb_growthrate }}
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>费用明细{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <fee-type-field
              :label="customLabel.fbd_itemname || '费用类型'"
              v-model="item.fbd_itemname"
              slot="fbd_itemname"
              @select="onSelectFeeType($event, item)"
            />
            <div
              class="weui-cell weui-cell_select weui-cell_select-after"
              slot="fbd_feetype"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_feetype || "费用类别"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <select
                  class="weui-select"
                  v-model="form.main.fbd_feetype"
                  placeholder="请选择"
                >
                  <option>销售费用</option>
                  <option>管理费用</option>
                  <option>财务费用</option>
                  <option>研发费用</option>
                  <option>制造费用</option>
                  <option>其他</option>
                </select>
              </div>
            </div>
            <div class="weui-cell" slot="fbd_total">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_total || "本年预算总额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ numberFormat(item.fbd_total, "#,##0.00") }}
              </div>
            </div>
            <div class="weui-cell" slot="fbd_pretotal">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_pretotal || "上年预算总额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ numberFormat(item.fbd_pretotal, "#,##0.00") }}
              </div>
            </div>
            <div class="weui-cell" slot="fbd_growthrate">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_growthrate || "实际增长率%"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.fbd_growthrate }}
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount1">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount1 || "1月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount1"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount2">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount2 || "2月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount2"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount3">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount3 || "3月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount3"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount4">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount4 || "4月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount4"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount5">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount5 || "5月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount5"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount6">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount6 || "1月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount6"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount7">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount7 || "7月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount7"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount8">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount8 || "8月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount8"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount9">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount9 || "9月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount9"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount10">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount10 || "10月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount10"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount11">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount11 || "11月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount11"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fbd_amount12">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fbd_amount12 || "12月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fbd_amount12"
                  placeholder="请填写"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.fb_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import FileField from "@/components/field/FileField.vue";
import FeeTypeField from "@/components/field/FeeTypeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    DepartmentField,
    EmployeeField,
    FileField,
    FeeTypeField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/feebudget",
      codeField: "fb_code",
      statusField: "fb_statuscode",
      caller: "FeeBudget",
      xtype: "oa-feebudget-formpanel",
      form: {
        main: {
          fb_date: null,
          fb_type: "个人",
          fb_emname: null,
          fb_dpname: null,
          fb_year: null,
          fb_total: null,
          fb_pretotal: null,
          fb_growthrate: null,
        },
        items: [
          {
            fbd_itemname: null,
            fbd_feetype: null,
            fbd_total: 0,
            fbd_pretotal: 0,
            fbd_growthrate: 0,
          },
        ],
      },
    };
  },
  mounted() {
    const me = this,
      main = me.form.main;
    if (!me.initId && !me.initData) {
      me.$loading({
        url: "/api/document/employee/read/current",
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data.main) {
            main.fb_emid = data.main.id;
            main.fb_emcode = data.main.em_code;
            main.fb_emname = data.main.em_name;
            main.fb_dpid = data.main.dp_id;
            main.fb_dpcode = data.main.dp_code;
            main.fb_dpname = data.main.dp_name;
          }
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  },
  methods: {
    selectYear() {
      var me = this,
        main = me.form.main,
        years = [];
      main.fb_year = new Date().getFullYear();
      for (let i = main.fb_year - 20, len = main.fb_year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        onConfirm: function (r) {
          main.fb_year = r[0].value;
        },
      });
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.fb_date) {
        me.$weui.topTips("请填写申请日期", 2000);
      } else if (!main.fb_type) {
        me.$weui.topTips("请选择预算类型", 2000);
      } else if (!main.fb_emname) {
        me.$weui.topTips("请填写申请人", 2000);
      } else if (!main.fb_dpname) {
        me.$weui.topTips("请填写申请部门", 2000);
      } else if (!main.fb_year) {
        me.$weui.topTips("请选择年份", 2000);
      } else {
        var count = 0;
        items.forEach(function (item, index) {
          if (!item.fbd_feetype) {
            me.$weui.topTips(`第${index + 1}行费用类别未填写`, 2000);
            return false;
          } else {
            count++;
            item.fbd_detno = count;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    onSelectFeeType(selection, item) {
      item.fbd_itemname = selection.fcs_itemname;
      item.fbd_feetype = selection.fcs_biztype;
    },
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },

    addItem() {
      var me = this,
        items = me.form.items;
      items.push({});
    },
    onSelectPleaseman(selected, main) {
      main.fb_emname = selected.em_name;
      main.fb_emcode = selected.em_code;
      main.fb_emid = selected.id;
      main.fb_dpname = selected.departmentDTO.dp_name;
      main.fb_dpcode = selected.departmentDTO.dp_code;
      main.fb_dpid = selected.departmentDTO.id;
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form.main;
      main.fb_dpid = selection.id;
      main.fb_code = selection.dp_code;
    },
  },
};
</script>